const BenefitCard = ({ item, index }) => {
    const { title, text, type } = item;

    return (
        <div key={title} className={`benefit-card ${type ? `benefit-card__${type}` : ''}`}>
            <div className="benefit-card__number">
                <span>{index + 1}</span>
            </div>
            <div className="description-demibold benefit-card__title">{title}</div>
            <div className="boby1 opacity-80">{text}</div>
        </div>
    );
};

export default BenefitCard;
